class APIResourceCache {
    constructor() {
        this.cache = {
            entities: {},
            users: {},
        };
    }

    hydrateResource(data) {
        if (!(data && data.resource)) return data;
        const resources = { ...data.resource };
        if (resources.entity) {
            this.cache.entities = resources.entity.reduce((memo, item) => {
                memo[item.entityId] = item;
                return memo;
            }, this.cache.entities);
        }
        if (resources.user) {
            this.cache.users = resources.user.reduce((memo, item) => {
                memo[item.userId] = item;
                return memo;
            }, this.cache.users);
        }
    }

    getUser(userId) {
        console.log(this.cache.users);

        return this.cache.users[userId];
    }

    getEntity(entityId) {
        return this.cache.entities[entityId];
    }
}

export const ApiResources = new APIResourceCache();
export default ApiResources;
